import {useToast} from "@shopify/app-bridge-react";
import {useCallback, useEffect, useState} from "react";
import Api from "../../../helpers/api";
import {
    Button,
    Modal,
    Select,
    DropZone,
    FormLayout,
    LegacyStack,
    Text,
    DataTable,
    Badge,
    OptionList, RadioButton, Banner
} from "@shopify/polaris";
import {formatDateToUsFormat} from "../../Dates";
import ImportsList from "./ImportsList";

export default ({
    loading = false,
    setLoading = () => {},
}) => {
    const toast = useToast();

    const [directories, setDirectories] = useState([]);
    const [directory, setDirectory] = useState(null);
    const [modalActive, setModalActive] = useState(false);
    const [importing, setImporting] = useState(false);

    //It's used to reload the list after we start new import
    const [listReload, setListReload] = useState(0);

    const onClose = () => {
        setDirectory(null);
        setModalActive(false);
    };

    useEffect(() => {
        loadDirectories();
    }, []);

    const loadDirectories = () => {
        setLoading(true);

        Api
            .getDirectoriesList()
            .then(({data}) => {
                setDirectories(data.data);
                if (data.data.length) {
                    setDirectory(data.data[0]);
                }
                setImporting(data.importing ?? false);
            })
            .catch(() => {
                toast.show("Server error. Please try again");
            })
            .finally(() => {
                setLoading(false);
            })
    }

    const importImages = () => {
        if (!directory) {
            toast.show("You need to select Directory first");
            return;
        }

        setLoading(true);

        Api
            .importImages(directory)
            .then(() => {
                toast.show("Images Import has been started");
                setImporting(true);
            })
            .catch(() => {
                toast.show("Server error. Please try again");
            })
            .finally(() => {
                setLoading(false);
            })
    }

    return (<Modal
        open={modalActive}
        title={"Images Import"}
        activator={<Button
            variant='primary'
            onClick={() => setModalActive(true)}
        >Import Images</Button>}
        onClose={onClose}
        primaryAction={{
            content: "Import",
            onAction: importImages,
            loading: loading,
            disabled: loading || importing
        }}
        secondaryActions={[
            {
                content: "Close",
                onAction: onClose,
            }
        ]}
        size={'large'}
    >
        <Modal.Section>
            <LegacyStack spacing={'loose'} vertical>
                {importing && (<Banner tone={'info'} title={"The images import process is currently running."}></Banner>)}
                <Select
                    placeholder={"-- Select Directory --"}
                    label={"Directories"}
                    disabled={loading || importing}
                    value={directory}
                    onChange={(val) => {
                        setDirectory(val.toString());
                    }}
                    options={directories.map((directory) => {return {
                        label: directory,
                        value: directory,
                    }})}
                    requiredIndicator
                />
            </LegacyStack>
        </Modal.Section>

        <Modal.Section>
            <ImportsList type={'images'} loading={loading} listReload={listReload} onRefresh={loadDirectories} />
        </Modal.Section>
    </Modal>);
}
